import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { 
  selectCurrentNarration, 
  selectCaptionsVisible,
  setCaptionsVisible
} from '../hostStateSlice';
import ClosedCaptioning from './ClosedCaptioning';
import logging from 'utils/logging';

const log = logging.getLogger('ClosedCaptioningContainer');
log.setLevel('info');

/**
 * Container component that connects ClosedCaptioning to Redux
 * Automatically displays captions when narration is being played
 */
const ClosedCaptioningContainer = () => {
  const dispatch = useDispatch();
  const currentNarration = useSelector(selectCurrentNarration);
  const captionsVisible = useSelector(selectCaptionsVisible);
  
  const handleHide = () => {
    log.debug('Hiding captions');
    dispatch(setCaptionsVisible(false));
  };

  log.debug(`Current narration: ${currentNarration} is visible: ${captionsVisible}`);
  
  // Don't render if no narration or captions are hidden
  if (!currentNarration || !captionsVisible) {
    if (captionsVisible && !currentNarration) {
      log.warn('Captions set to visible but no current narration available');
    }
    return null;
  }

  const shouldShow = !!(currentNarration.text && captionsVisible);
  
  return (
    <ClosedCaptioning 
      text={currentNarration.text}
      visible={shouldShow}
      onHide={handleHide}
    />
  );
};

export default ClosedCaptioningContainer; 